import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Exige valor numérico maior que zero (vazio também é inválido).
 * Usado quando a configuração de campos obrigatórios marca um valor monetário/percentual
 * cujo padrão é 0 (ex.: limite de crédito, preço na lista padrão, percentual de comissão).
 * Guarde a instância retornada para poder remover o validator com removeValidators.
 */
export function valorMaiorQueZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valor = Number(control.value);
    return control.value !== null && control.value !== '' && !isNaN(valor) && valor > 0
      ? null
      : { valorMaiorQueZero: true };
  };
}
